<div class="tw-flex tw-flex-col tw-min-h-0 tw-font-inter">
  <div class="tw-flex tw-flex-row tw-items-center tw-bg-blue-50 tw-py-2 tw-px-3 tw-border tw-rounded-md tw-border-blue-100 tw-mb-2 tw-gap-3 tw-shrink-0">
    <h1 class="tw-text-sm tw-font-medium tw-text-gray-900 tw-flex-1 tw-min-w-0">User</h1>
    <h1 class="tw-text-sm tw-font-medium tw-text-gray-900 tw-hidden md:tw-block md:tw-w-[118px] md:tw-shrink-0 md:tw-text-center">Role</h1>
    <h1 class="tw-text-sm tw-font-medium tw-text-gray-900 tw-hidden md:tw-block md:tw-w-[97px] md:tw-shrink-0 md:tw-text-center">Status</h1>
    <h1 class="tw-text-sm tw-font-medium tw-text-gray-900 tw-hidden md:tw-block md:tw-w-[82px] md:tw-shrink-0 tw-text-end">Last seen</h1>
  </div>

  <div #viewportHost class="tw-relative tw-flex-1 tw-min-h-0">
    @if (isLoading() && !users().length) {
        <ngx-skeleton-loader [theme]="{ height: '72px', width: '100%', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ height: '72px', width: '100%', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ height: '72px', width: '100%', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
    } @else {
      <cdk-virtual-scroll-viewport
        autosize
        class="users-list-viewport tw-w-full"
        [minBufferPx]="200"
        [maxBufferPx]="400"
        (scroll)="onViewportScroll()"
      >
        <div *cdkVirtualFor="let user of displayUsers(); trackBy: trackByUserId" class="tw-pb-2 tw-box-sizing-border-box">
          <app-user-card
            [user]="user"
            [isStatusActionsDisabled]="isStatusActionsDisabled()"
            (statusActionSelected)="onStatusActionSelected($event)"
            (updateTeamMemberRole)="onUpdateTeamMemberRole($event)"
          />
        </div>
      </cdk-virtual-scroll-viewport>

      @if (isLoadingMore()) {
        <progress-circle
          class="tw-absolute tw-right-0 tw-bottom-0.5 tw-left-0 tw-flex tw-items-center tw-justify-center tw-pointer-events-none"
          colorClasses="tw-border-blue-500 tw-border-r-gray-300"
        ></progress-circle>
      }
    }
  </div>
</div>
